import printJS from "print-js"
import { api_URL } from "./Constantes";
export const printJournalSaisie = () => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
    const url = `${api_URL}/Print/Brouillard/Brouillard_PC`;

    fetch(url, {
      method: 'GET',  
      headers: {
        'Accept': 'application/pdf',
        'Authorization': 'Bearer dev1',
        'user_id': userId,
        'username': username,
      },
    })
    .then(response => {
      if (response.ok) {
        return response.blob();
      }
      // Gérer les réponses non réussies ici (par exemple, afficher un message d'erreur)
      throw new Error('Erreur lors de la récupération du document: ' + response.statusText);
    })
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      // Utilisez printJS ou une autre méthode pour ouvrir le PDF
      // Assurez-vous que printJS est correctement intégré et disponible
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF:', error));
};
